import { X } from "lucide-react";

const HIDE = new Set(["_id", "password", "password_hash", "initial_password"]);
const titleCase = (k) => k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
const isUrl = (v) => typeof v === "string" && /^https?:\/\//.test(v);
const isDate = (k, v) => typeof v === "string" && /(_at|_date)$/.test(k) && !Number.isNaN(Date.parse(v));

function Value({ k, v }) {
  if (v === null || v === undefined || v === "") return <span className="text-[var(--ff-text-muted)]">—</span>;
  if (typeof v === "boolean") return <span>{v ? "Yes" : "No"}</span>;
  if (Array.isArray(v)) {
    if (v.length === 0) return <span className="text-[var(--ff-text-muted)]">—</span>;
    if (typeof v[0] === "object") return <pre className="text-xs bg-stone-50 rounded p-2 overflow-x-auto">{JSON.stringify(v, null, 2)}</pre>;
    return <div className="flex flex-wrap gap-1.5">{v.map((x, i) => <span key={i} className="text-[11px] px-2 py-0.5 rounded-full bg-stone-100 text-stone-700">{String(x)}</span>)}</div>;
  }
  if (typeof v === "object") return <pre className="text-xs bg-stone-50 rounded p-2 overflow-x-auto">{JSON.stringify(v, null, 2)}</pre>;
  if (isUrl(v)) return <a href={v} target="_blank" rel="noreferrer" className="underline text-[var(--ff-primary)] break-all">{v}</a>;
  if (isDate(k, v)) return <span>{new Date(v).toLocaleString()}</span>;
  return <span className="break-words whitespace-pre-wrap">{String(v)}</span>;
}

export default function AdminRecordDrawer({ record, title = "Details", onClose }) {
  if (!record) return null;
  const entries = Object.entries(record).filter(([k, v]) => !HIDE.has(k) && v !== null && v !== undefined && v !== "");
  return (
    <div className="fixed inset-0 z-[65] flex justify-end" data-testid="admin-record-drawer">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full max-w-lg bg-white h-full overflow-y-auto shadow-2xl">
        <div className="sticky top-0 bg-white border-b border-[var(--ff-border)] p-4 flex items-center justify-between z-10">
          <p className="font-display text-xl">{title}</p>
          <button onClick={onClose} data-testid="admin-record-drawer-close" className="p-1 hover:bg-stone-100 rounded"><X size={18} /></button>
        </div>
        <dl className="p-5 space-y-3">
          {entries.map(([k, v]) => (
            <div key={k} className="grid grid-cols-[9rem_1fr] gap-3 text-sm border-b border-[var(--ff-border)] pb-2">
              <dt className="text-[var(--ff-text-muted)] text-xs uppercase tracking-wider pt-0.5">{titleCase(k)}</dt>
              <dd className="text-[var(--ff-text-secondary)]"><Value k={k} v={v} /></dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
